/**
 * Mock personal records data for development.
 * Provides realistic PR data matching the mock workout history.
 */
import { subDays } from 'date-fns';
import { MOCK_CURRENT_USER_ID } from './mock-users.data';

const now = new Date();

const makePR = (exerciseName, maxWeight, maxVolume, maxReps, history) => ({
  exerciseName,
  userId: MOCK_CURRENT_USER_ID,
  maxWeight,
  maxVolume,
  maxReps,
  history: history || [],
  updatedAt: maxWeight?.date || maxVolume?.date || maxReps?.date || now.toISOString(),
});

export const MOCK_PERSONAL_RECORDS = [
  makePR(
    'Bench Press',
    { value: 205, unit: 'lbs', reps: 6, date: subDays(now, 0).toISOString(), workoutId: 'mock_wkt_01' },
    { value: 1560, unit: 'lbs', weight: 195, reps: 8, date: subDays(now, 0).toISOString(), workoutId: 'mock_wkt_01' },
    { value: 10, weight: 185, unit: 'lbs', date: subDays(now, 0).toISOString(), workoutId: 'mock_wkt_01' },
    [
      { type: 'weight', value: 205, date: subDays(now, 0).toISOString() },
      { type: 'weight', value: 195, date: subDays(now, 11).toISOString() },
      { type: 'weight', value: 185, date: subDays(now, 34).toISOString() },
      { type: 'weight', value: 175, date: subDays(now, 52).toISOString() },
      { type: 'weight', value: 165, date: subDays(now, 66).toISOString() },
      { type: 'weight', value: 155, date: subDays(now, 78).toISOString() },
      { type: 'weight', value: 145, date: subDays(now, 85).toISOString() },
      { type: 'weight', value: 135, date: subDays(now, 90).toISOString() },
    ]
  ),
  makePR(
    'Squat',
    { value: 275, unit: 'lbs', reps: 5, date: subDays(now, 2).toISOString(), workoutId: 'mock_wkt_03' },
    { value: 1375, unit: 'lbs', weight: 275, reps: 5, date: subDays(now, 2).toISOString(), workoutId: 'mock_wkt_03' },
    { value: 8, weight: 165, unit: 'lbs', date: subDays(now, 85).toISOString(), workoutId: 'mock_wkt_41' },
    [
      { type: 'weight', value: 275, date: subDays(now, 2).toISOString() },
      { type: 'weight', value: 255, date: subDays(now, 32).toISOString() },
      { type: 'weight', value: 245, date: subDays(now, 40).toISOString() },
      { type: 'weight', value: 235, date: subDays(now, 61).toISOString() },
      { type: 'weight', value: 225, date: subDays(now, 71).toISOString() },
      { type: 'weight', value: 195, date: subDays(now, 80).toISOString() },
      { type: 'weight', value: 175, date: subDays(now, 85).toISOString() },
    ]
  ),
  makePR(
    'Deadlift',
    { value: 365, unit: 'lbs', reps: 3, date: subDays(now, 1).toISOString(), workoutId: 'mock_wkt_02' },
    { value: 1675, unit: 'lbs', weight: 335, reps: 5, date: subDays(now, 1).toISOString(), workoutId: 'mock_wkt_02' },
    { value: 5, weight: 315, unit: 'lbs', date: subDays(now, 1).toISOString(), workoutId: 'mock_wkt_02' },
    [
      { type: 'weight', value: 365, date: subDays(now, 1).toISOString() },
      { type: 'weight', value: 345, date: subDays(now, 30).toISOString() },
      { type: 'weight', value: 325, date: subDays(now, 47).toISOString() },
      { type: 'weight', value: 305, date: subDays(now, 68).toISOString() },
      { type: 'weight', value: 275, date: subDays(now, 82).toISOString() },
      { type: 'weight', value: 255, date: subDays(now, 90).toISOString() },
    ]
  ),
  makePR(
    'Overhead Press',
    { value: 105, unit: 'lbs', reps: 8, date: subDays(now, 0).toISOString(), workoutId: 'mock_wkt_01' },
    { value: 950, unit: 'lbs', weight: 95, reps: 10, date: subDays(now, 0).toISOString(), workoutId: 'mock_wkt_01' },
    { value: 10, weight: 95, unit: 'lbs', date: subDays(now, 0).toISOString(), workoutId: 'mock_wkt_01' },
    [
      { type: 'weight', value: 105, date: subDays(now, 0).toISOString() },
      { type: 'weight', value: 100, date: subDays(now, 25).toISOString() },
      { type: 'weight', value: 95, date: subDays(now, 34).toISOString() },
      { type: 'weight', value: 90, date: subDays(now, 52).toISOString() },
      { type: 'weight', value: 85, date: subDays(now, 66).toISOString() },
    ]
  ),
  makePR(
    'Barbell Row',
    { value: 165, unit: 'lbs', reps: 8, date: subDays(now, 1).toISOString(), workoutId: 'mock_wkt_02' },
    { value: 1550, unit: 'lbs', weight: 155, reps: 10, date: subDays(now, 1).toISOString(), workoutId: 'mock_wkt_02' },
    { value: 10, weight: 155, unit: 'lbs', date: subDays(now, 1).toISOString(), workoutId: 'mock_wkt_02' },
    [
      { type: 'weight', value: 165, date: subDays(now, 1).toISOString() },
      { type: 'weight', value: 155, date: subDays(now, 15).toISOString() },
      { type: 'weight', value: 150, date: subDays(now, 38).toISOString() },
      { type: 'weight', value: 145, date: subDays(now, 52).toISOString() },
      { type: 'weight', value: 135, date: subDays(now, 75).toISOString() },
    ]
  ),
  makePR(
    'Lat Pulldown',
    { value: 150, unit: 'lbs', reps: 10, date: subDays(now, 1).toISOString(), workoutId: 'mock_wkt_02' },
    { value: 1680, unit: 'lbs', weight: 140, reps: 12, date: subDays(now, 1).toISOString(), workoutId: 'mock_wkt_02' },
    { value: 12, weight: 140, unit: 'lbs', date: subDays(now, 1).toISOString(), workoutId: 'mock_wkt_02' },
    [
      { type: 'weight', value: 150, date: subDays(now, 1).toISOString() },
      { type: 'weight', value: 140, date: subDays(now, 38).toISOString() },
      { type: 'weight', value: 130, date: subDays(now, 59).toISOString() },
    ]
  ),
  makePR(
    'Incline Dumbbell Press',
    { value: 65, unit: 'lbs', reps: 10, date: subDays(now, 0).toISOString(), workoutId: 'mock_wkt_01' },
    { value: 720, unit: 'lbs', weight: 60, reps: 12, date: subDays(now, 0).toISOString(), workoutId: 'mock_wkt_01' },
    { value: 12, weight: 60, unit: 'lbs', date: subDays(now, 0).toISOString(), workoutId: 'mock_wkt_01' },
    [
      { type: 'weight', value: 65, date: subDays(now, 0).toISOString() },
      { type: 'weight', value: 60, date: subDays(now, 34).toISOString() },
      { type: 'weight', value: 50, date: subDays(now, 78).toISOString() },
    ]
  ),
  makePR(
    'Pull-Up',
    null,
    null,
    { value: 10, weight: 0, unit: 'lbs', date: subDays(now, 6).toISOString(), workoutId: 'mock_wkt_06' },
    [
      { type: 'reps', value: 10, date: subDays(now, 6).toISOString() },
      { type: 'reps', value: 8, date: subDays(now, 47).toISOString() },
    ]
  ),
  makePR(
    'Leg Press',
    { value: 400, unit: 'lbs', reps: 10, date: subDays(now, 2).toISOString(), workoutId: 'mock_wkt_03' },
    { value: 4320, unit: 'lbs', weight: 360, reps: 12, date: subDays(now, 2).toISOString(), workoutId: 'mock_wkt_03' },
    { value: 12, weight: 360, unit: 'lbs', date: subDays(now, 2).toISOString(), workoutId: 'mock_wkt_03' },
    [
      { type: 'weight', value: 400, date: subDays(now, 2).toISOString() },
      { type: 'weight', value: 380, date: subDays(now, 32).toISOString() },
      { type: 'weight', value: 360, date: subDays(now, 61).toISOString() },
      { type: 'weight', value: 340, date: subDays(now, 80).toISOString() },
    ]
  ),
  makePR(
    'Barbell Curl',
    { value: 75, unit: 'lbs', reps: 10, date: subDays(now, 1).toISOString(), workoutId: 'mock_wkt_02' },
    { value: 780, unit: 'lbs', weight: 65, reps: 12, date: subDays(now, 1).toISOString(), workoutId: 'mock_wkt_02' },
    { value: 12, weight: 65, unit: 'lbs', date: subDays(now, 1).toISOString(), workoutId: 'mock_wkt_02' },
    [
      { type: 'weight', value: 75, date: subDays(now, 1).toISOString() },
      { type: 'weight', value: 65, date: subDays(now, 30).toISOString() },
      { type: 'weight', value: 55, date: subDays(now, 82).toISOString() },
    ]
  ),
];
